import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle } from "lucide-react";
import { Wordmark } from "./Wordmark";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="mb-4">
              <Wordmark variant="light" size="lg" />
            </div>
            <p className="text-sm leading-relaxed text-slate-400 max-w-sm">
              SparkNext Pathways is building the financial literacy ecosystem for
              the next generation of K-12 learners — combining education and
              fintech through innovative digital platforms.
            </p>
            <p className="mt-4 text-xs uppercase tracking-[0.2em] text-amber-500 font-semibold">
              Registered in India
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-white mb-4">Explore</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/"
                  data-testid="footer-link-home"
                  className="hover:text-white transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  data-testid="footer-link-about"
                  className="hover:text-white transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  data-testid="footer-link-services"
                  className="hover:text-white transition-colors"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  data-testid="footer-link-contact"
                  className="hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="mailto:sparknextpathways@gmail.com"
                  data-testid="footer-email-link"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors break-all"
                >
                  <Mail className="w-4 h-4 text-amber-500 shrink-0" />
                  sparknextpathways@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+917619552312"
                  data-testid="footer-phone-link"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Phone className="w-4 h-4 text-amber-500 shrink-0" />
                  +91 76195 52312
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/917619552312"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                >
                  <MessageCircle className="w-4 h-4 text-amber-500 shrink-0" />
                  WhatsApp Chat
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-slate-500">
          <p data-testid="footer-copy">
            © {new Date().getFullYear()} SparkNext Pathways Private Limited. All
            rights reserved.
          </p>
          <p>Empowering financially smart students.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
